<script>import { attrValue } from "../../../utils/html";
import IconLottie from "../IconLottie.svelte";
import Hint from "../Hint.svelte";
export let props;
let ref;
</script>

<div
	class={props?.classNames
		? attrValue([
				props?.classNames,
				'tag inline-flex flex-shrink-0 flex-grow-0 select-none flex-nowrap items-center justify-center gap-1 self-center rounded-xl px-2.5 py-1.5 text-base'
			])
		: ''}
	bind:this={ref}
>
	{#if props?.iconLeft}
		<IconLottie name={props.iconLeft} size="small" parentRef={props.parentRef ?? ref} />
	{/if}
	{#if props?.label}
		<span class="truncate first-letter:uppercase">{@html props.label}</span>
	{:else}
		<slot />
	{/if}
	{#if props.hint}
		<Hint tooltip={props.hint} parentRef={props.parentRef ?? ref} />
	{/if}
	{#if props?.iconRight}
		<IconLottie name={props.iconRight} size="small" parentRef={props.parentRef ?? ref} />
	{/if}
</div>
